import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { useForm } from 'react-hook-form';

import Toolbar from '../components/Toolbar'
import ListSinals from '../components/ListSinais';
import ItemSinal from '../components/ItemSinal';

import SearchVideo from '../components/SearchVideo';

import { IonPage, IonButton, IonIcon, IonContent, IonGrid, IonRow, IonCol, IonItem, IonInput, IonSelect, IonSelectOption, IonAlert, IonLabel, IonModal, IonLoading, IonBadge } from '@ionic/react'
import { logoYoutube, videocam } from 'ionicons/icons'

import { Word } from '../models/Word'
import { Sinal } from '../models/Sinal';
import { IVideoYoutube } from '../models/IVideoYoutube';

import WordService from '../services/WordService'

import estados from '../data/siglas-estados-br.json'
import classes from '../data/classes-gramaticais.json'
import categoryService from 'services/CategoryService';
import ToolbarModal from '../components/ToolbarModal';
import authService from '../services/AuthService';
import Routers from 'Routers';
import { Category } from 'models/Category';

const AddWord: React.FC = () => {
  const history = useHistory();

  const { getValues, setValue, handleSubmit, errors, register } = useForm({
    defaultValues: new Word()
  });

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [showModalSignal, setShowModalSignal] = useState<boolean>(false)
  const [showModalYt, setShowModalYt] = useState<boolean>(false)
  const [showLoading, setShowLoading] = useState<boolean>(false)
  const [hand, setHand] = useState('right')
  const [tags, setTags] = useState<Array<string>>([])
  const [categories, setCategories] = useState<Category[]>([])

  const inputFile = React.createRef<HTMLInputElement>()

  const onAddTag = (e: any) => {
    const newTag: string = e.target.value
      .replace(',', '')
      .replace(';', '')
      .replace('#', '')
      .trim();

    if (newTag) {
      if ([';', ',', 'Enter'].includes(e.key)) {
        e.preventDefault();
        e.target.value = ''

        setTags([...tags, newTag]);
      }
    }
  }

  const removeTag = (position: number) => {
    const newTags = [...tags];
    newTags.splice(position, 1);

    setTags([...newTags]);
  }

  const fetchCategories = useCallback(async () => {
    categoryService.getCategories().then(_categories => {
      setCategories(_categories)
    })
  }, [])

  useEffect(() => {
    fetchCategories()
  }, [fetchCategories])

  function selectSinal(sinal: Sinal) {
    if (hand === 'left') {
      setValue('signalLeft', sinal.id)
    } else if (hand === 'right') {
      setValue('signalRight', sinal.id)
    }

    setShowModalSignal(false)
  }

  function selectVideoYt(video?: IVideoYoutube) {
    console.log(video)
    if (video) {
      setValue('urlYoutube', `https://www.youtube.com/watch?v=${video.id.videoId}`)
    }
    setShowModalYt(false)
  }

  function onSelectSinal(newHand: string) {
    setHand(newHand)
    setShowModalSignal(true)
  }

  function onSubmit() {
    const user = authService.user()
    const { 
      state, 
      category, 
      text, 
      grammar, 
      signalLeft, 
      signalRight, 
      synonymous, 
      urlYoutube, 
      videoFile 
    } = getValues()

    if (user !== null) {
      const newWord = Object.assign(new Word(), {
        text,
        state,
        grammar,
        synonymous,
        signalRight,
        signalLeft,
        urlYoutube,
        videoFile,
        owner: user.uid,
        category,
        tags
      })

      console.log(newWord)

      WordService.saveWord(newWord)
        .then(idNewWord => {
          history.replace(`${Routers.DETAILS_WORD_ROUTER}?wordId=${idNewWord}`)
        })
        .catch(console.log)
    }

  }

  function btnCancelSignal() {
    history.replace(Routers.WORDS_ROUTER)
  }

  function onUploadVideo(files: FileList | null) {
    if (files) {
      setShowLoading(true)

      WordService.uploadVideo(files[0])
        .then(ref => {
          setValue('videoFile', ref.toString())
          setShowLoading(false)
        })
        .catch(err => {
          console.log(err)
          setShowLoading(false)
        })
    }
  }

  function onSelectVideoYT() {
    setShowModalYt(true)
  }

  function showError(_fieldName: string, msgError = 'O campo é obrigatório') {
    return (
      (errors as any)[_fieldName] &&
      <div
        style={{
          color: 'red',
          padding: 5,
          paddingLeft: 12,
          fontSize: 'smaller'
        }}
      >
        {msgError}
      </div>
    )
  }

  return (
    <IonPage>
      <Toolbar menuBtn={true} title="Adicionar Palavra" infoBtn={false} />

      <IonModal isOpen={showModalSignal} onDidDismiss={() => setShowModalSignal(false)} swipeToClose={true} keyboardClose={true}>
        <ToolbarModal title="Selecione o sinal" onClose={() => setShowModalSignal(false)} />
        <ListSinals selectMode={true} onSelect={sinal => selectSinal(sinal)} />
      </IonModal>

      <IonModal isOpen={showModalYt} onDidDismiss={() => setShowModalYt(false)} swipeToClose={true} keyboardClose={true} >
        <ToolbarModal title="Selecione o sinal" onClose={() => setShowModalYt(false)} />
        <SearchVideo onSelect={video => selectVideoYt(video)} initialSearchTerm={`${getValues().text} libras`} />
      </IonModal>


      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        header={'Importante'}
        message={'É preciso gravar o vídeo na posição horizontal (modo paisagem)'}
        buttons={['OK']}
      />

      <IonLoading
        isOpen={showLoading}
        message={'Enviando vídeo...'}
      />

      <IonContent className="ion-padding">
        <IonGrid fixed>
          <IonRow className="ion-justify-content-center">
            {
              getValues().signalRight &&
              <IonCol size="auto">
                <ItemSinal label="Mão Direita" item={getValues().signalRight} />
              </IonCol>
            }
            {
              getValues().signalLeft &&
              <IonCol size="auto">
                <ItemSinal label="Mão Esquerda" item={getValues().signalLeft} />
              </IonCol>
            }
          </IonRow>
        </IonGrid>

        <form onSubmit={handleSubmit(onSubmit)}>
          <IonItem>
            <IonLabel position="floating">Nome *</IonLabel>
            <IonInput type="text" ref={register({ required: true, min: 2 })} name="text" />
          </IonItem>
          {
            showError('text')
          }

          <IonItem>
            <IonLabel position="floating">Sinônimo *</IonLabel>
            <IonInput name="synonymous" ref={register({ required: true, min: 2 })} />
          </IonItem>
          {
            showError('synonymous')
          }

          <IonItem>
            <IonLabel position="floating">Classe Gramatical *</IonLabel>
            <IonSelect placeholder="Selecionar" name="grammar" ref={register({ required: true })}>
              {classes.map((classe, index) =>
                <IonSelectOption value={classe} key={index}>{classe}</IonSelectOption>
              )}
            </IonSelect>
          </IonItem>
          {
            showError('grammar')
          }

          <IonItem>
            <IonLabel position="floating">Categoria *</IonLabel>
            <IonSelect name="category" ref={register({ required: true })} placeholder="Selecionar">
              {categories.map(category =>
                <IonSelectOption value={category.id} key={category.id}>{category.name}</IonSelectOption>
              )}
            </IonSelect>
          </IonItem>
          {
            showError('category')
          }

          <IonItem>
            <IonLabel position="floating">Estado de Origem *</IonLabel>
            <IonSelect ref={register({ required: true })} placeholder="Selecionar" name="state">
              {estados.map((estado, index) =>
                <IonSelectOption value={estado} key={index}>{estado}</IonSelectOption>
              )}
            </IonSelect>
          </IonItem>
          {
            showError('state')
          }

          <IonItem>
            <IonLabel position="floating">Sinal na Mão Direita *</IonLabel>
            <IonInput name="signalRight" ref={register({ required: true })} />
            <IonButton fill="outline" slot="end" style={{ marginTop: '18px' }} onClick={() => onSelectSinal('right')}>Selecionar</IonButton>
          </IonItem>
          {
            showError('signalRight')
          }

          <IonItem>
            <IonLabel position="floating">Sinal na Mão Esquerda</IonLabel>
            <IonInput name="signalLeft" ref={register()} />
            <IonButton fill="outline" slot="end" style={{ marginTop: '18px' }} onClick={() => onSelectSinal('left')}>Selecionar</IonButton>
          </IonItem>

          <IonItem>
            <IonLabel position="floating">YouTube URL</IonLabel>
            <IonInput placeholder="Link do Youtube" name="urlYoutube" ref={register} />
            <IonButton fill="outline" slot="end" style={{ marginTop: '18px' }} onClick={() => onSelectVideoYT()}>
              <IonIcon icon={logoYoutube} slot="start"></IonIcon> Selecionar do Youtube
            </IonButton>
          </IonItem>

          <IonItem>
            <IonLabel position="floating">Vídeo gravado</IonLabel>
            <IonInput placeholder="Que tal selecionar um video gravado?" name="videoFile" ref={register} />
            <IonButton fill="outline" slot="end" style={{ marginTop: '18px' }} onClick={() => inputFile.current?.click()}>
              <IonIcon icon={videocam} slot="start"></IonIcon>
              <input id="file" hidden ref={inputFile} type="file" accept="video/*" onChange={e => onUploadVideo(e.target.files)} />
              <label htmlFor="file">Selecionar Vídeo*</label>
            </IonButton>
          </IonItem>

          <IonItem>
            <IonLabel position="floating"> Tags *</IonLabel>
            <IonInput type="text" onKeyUp={onAddTag} />
            <IonGrid>
              {
                tags.map((tag, i) =>
                  <IonBadge key={i} style={{ margin: '0 2px' }} onClick={() => removeTag(i)}>
                    #{tag}
                  </IonBadge>
                )
              }
            </IonGrid>
          </IonItem>

          <IonGrid>
            <IonRow className="ion-justify-content-end">
              <IonCol size="auto">
                <IonButton onClick={btnCancelSignal} fill="clear" type="button">Cancelar</IonButton>
              </IonCol>
              <IonCol size="auto">
                <IonButton fill="solid" type="submit">Salvar</IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </form>
      </IonContent>
    </IonPage >
  )
}

export default AddWord;
